<template>
  <portal to="sidebar-menu">
    <div>
      <slot name="before"></slot>
      <nav-list class="mt-2" :items="allNavigationItems"></nav-list>
      <text-language-select/>
      <slot name="after"></slot>
    </div>
  </portal>
</template>
<script>

  import { getRouteName, routeTypes } from 'src/config/routeTypes'
  import entities from 'src/config/entities'
  import SavedFilters from 'src/components/Filters/SavedFilters'
  import TextLanguageSelect from 'src/components/TextLanguageSelect'
  export default {
    name: 'content-left-menu',
    components: {
      SavedFilters,
      TextLanguageSelect,
    },
    props: {
      navigationItems: {
        type: Array,
        default: () => []
      }
    },
    data () {
      return {
        entities,
        baseNavigationItems: [
          {
            type: 'group',
            name: this.$t('jobBoard.list.title'),
            hide: !this.$can('admin-jobboard-all'),
          },
          {
            routeName: getRouteName(routeTypes.LIST, entities.JOB_BOARD),
            hide: !this.$can('admin-jobboard-all'),
            name: this.$t('generic.all')
          },
          {
            type: 'group',
            name: this.$t('content.menu.cms.title')
          },
          {
            routeName: getRouteName(routeTypes.LIST, entities.CMS),
            name: this.$t('content.menu.cms')
          },
          {
            type: 'group',
            name: this.$t('content.menu.landingPages.title')
          },
          {
            routeName: getRouteName(routeTypes.LIST, entities.LANDING_PAGE),
            name: this.$t('content.menu.landingPage')
          },
          {
            type: 'group',
            name: this.$t('content.menu.newsletter.title')
          },
          {
            routeName: getRouteName(routeTypes.LIST, entities.NEWSLETTER),
            name: this.$t('content.menu.newsletter')
          },
        ]
      }
    },
    computed: {
      allNavigationItems () {
        return this.baseNavigationItems.concat(this.navigationItems)
      }
    }
  }
</script>
<style>
</style>
